<template>
  <vx-card no-shadow>

    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
      <form @submit.prevent="handleSubmit(onClickSubmit)" autocomplete="off">


        <vs-divider class="my-4" style="opacity: 1.0" color="" position="center">Heavy Metals</vs-divider>


        <vs-table :data="form.heavy_metal"  stripe class="table-dark-inverted table-auto vs-con-loading__container">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="15%">Name</vs-th>
            <vs-th style="font-weight: normal" width="20%">Maximum levels</vs-th>
            <vs-th style="font-weight: normal" width="20%">Frequency of testing</vs-th>
            <vs-th style="font-weight: normal" width="20%">Laboratory Accreditation</vs-th>
            <vs-th style="font-weight: normal" width="20%">Method</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].name">
                {{heavy_metal_display_names[indextr]}}
              </vs-td>
              <vs-td :data="data[indextr].max">
                <ValidationProvider :vid="indextr+'heavy_metal_max'" :name="indextr+'heavy_metal_max'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].frequency">
                <ValidationProvider :vid="indextr+'heavy_metal_frequency'" :name="indextr+'heavy_metal_frequency'" rules="" v-slot="{ errors }">
                  <v-select :append-to-body="true"  :closeOnSelect="true" v-model="data[indextr].frequency"
                            :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly', 'each batch']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].accreditation">
                <ValidationProvider :vid="indextr+'heavy_metal_accreditation'" :name="indextr+'heavy_metal_accreditation'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr].method">
                <ValidationProvider :vid="indextr+'heavy_metal_method'" :name="indextr+'heavy_metal_method'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr].method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>

        <!--        <div v-for="(heavy_metal, index1) in form.heavy_metal" :key="index1">-->
        <!--          <div class="vx-row mb-3">-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index1+'legislative_name'" :name="index1+'legislative_name'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Name</small> <br>-->
        <!--                <span class="text-bold" style="font-weight: normal">{{ heavy_metal.name}}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index1+'max'" :name="index1+'max'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Maximum levels</small>-->
        <!--                <vs-input type="text" v-model="heavy_metal.max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index1+'frequency'" :name="index1+'frequency'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Frequency of testing</small>-->
        <!--                <v-select :closeOnSelect="true" v-model="heavy_metal.frequency" :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
        <!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index1+'accreditation'" :name="index1+'accreditation'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Laboratory Accreditation</small>-->
        <!--                <vs-input type="text" v-model="heavy_metal.accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index1+'method'" :name="index+'method'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Method</small>-->
        <!--                <vs-input type="text" v-model="heavy_metal.method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        </div>-->

        <!--heavy metal others-->
        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_other_heavy_metals" name="is_other_heavy_metals" rules="" v-slot="{ errors }">
              <small class="label">Others ?</small>
              <vs-switch v-model="form.is_other_heavy_metals" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="form.is_other_heavy_metals" v-for="(other, index2) in form.other_heavy_metal" :key="index2">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index2+'other_name'" :name="index2+'other_name'" rules="" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input type="text" v-model="other.name" name="name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index2+'other_max'" :name="index2+'other_max'" rules="" v-slot="{ errors }">
                <small class="label">Maximum levels</small>
                <vs-input type="text" v-model="other.max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index2+'other_frequency'" :name="index2+'other_frequency'" rules="required" v-slot="{ errors }">
                <small class="label">Frequency of testing</small>
                <!--                <vs-input type="text" v-model="other.frequency" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
                <v-select :append-to-body="true"  :closeOnSelect="true" v-model="other.frequency" :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index2+'other_accreditation'" :name="index2+'other_accreditation'" rules="" v-slot="{ errors }">
                <small class="label">Laboratory Accreditation</small>
                <vs-input type="text" v-model="other.accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index2+'other_method'" :name="index2+'other_method'" rules="" v-slot="{ errors }">
                <small class="label">Method</small>
                <vs-input type="text" v-model="other.method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.other_heavy_metal.length === 1" class="" @click="deleteOtherName(index2)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_other_heavy_metals"  @click="addOtherName" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add Other Name</vs-button>

        <!--heavy metal others end-->

        <vs-divider class="my-4" style="opacity: 1.0" color="" position="center">Pesticides and Pesticide Residues</vs-divider>

        <vs-table :data="form.residue"  :sst="false" stripe class="table-dark-inverted table-auto vs-con-loading__container">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="15%">Name</vs-th>
            <vs-th style="font-weight: normal" width="20%">Maximum levels</vs-th>
            <vs-th style="font-weight: normal" width="15%">Frequency of testing</vs-th>
            <vs-th style="font-weight: normal" width="20%">Laboratory Accreditation</vs-th>
            <vs-th style="font-weight: normal" width="20%">Method</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr2" v-for="(tr, indextr2) in data">

              <vs-td :data="data[indextr2].name">
                {{residue_display_names[indextr2]}}
              </vs-td>
              <vs-td :data="data[indextr2].max">
                <ValidationProvider :vid="indextr2+'residue_max'" :name="indextr2+'residue_max'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr2].max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr2].frequency">
                <ValidationProvider :vid="indextr2+'residue_frequency'" :name="indextr2+'residue_frequency'" rules="" v-slot="{ errors }">
                  <v-select :append-to-body="true" :closeOnSelect="true" v-model="data[indextr2].frequency"
                            :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly', 'each batch']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr2].accreditation">
                <ValidationProvider :vid="indextr2+'residue_accreditation'" :name="indextr2+'residue_accreditation'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr2].accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr2].method">
                <ValidationProvider :vid="indextr2+'residue_method'" :name="indextr2+'residue_method'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr2].method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>


        <!--        <div v-for="(residue, index4) in form.residue" :key="index4">-->
        <!--          <div class="vx-row mb-3">-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index4+'residue_name'" :name="index4+'residue_name'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Name</small> <br>-->
        <!--                <span class="text-bold" style="font-weight: normal">{{ residue.name}}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index4+'residue_max'" :name="index4+'residue_max'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Maximum levels</small>-->
        <!--                <vs-input type="text" v-model="residue.max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index4+'residue_frequency'" :name="index4+'residue_frequency'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Frequency of testing</small>-->
        <!--&lt;!&ndash;                <vs-input type="text" v-model="residue.frequency" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />&ndash;&gt;-->
        <!--                <v-select :closeOnSelect="true" v-model="residue.frequency" :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
        <!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index4+'residue_accreditation'" :name="index4+'residue_accreditation'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Laboratory Accreditation</small>-->
        <!--                <vs-input type="text" v-model="residue.accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index4+'residue_method'" :name="index4+'residue_method'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Method</small>-->
        <!--                <vs-input type="text" v-model="residue.method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        </div>-->

        <vs-divider class="my-4" style="opacity: 1.0" color="" position="center">Miscellaneous</vs-divider>

        <vs-table :data="form.miscellaneous"  :sst="false" stripe class="table-dark-inverted table-auto vs-con-loading__container">
          <template slot="thead">
            <vs-th style="font-weight: normal" width="15%">Name</vs-th>
            <vs-th style="font-weight: normal" width="20%">Maximum levels</vs-th>
            <vs-th style="font-weight: normal" width="15%">Frequency of testing</vs-th>
            <vs-th style="font-weight: normal" width="20%">Laboratory Accreditation</vs-th>
            <vs-th style="font-weight: normal" width="20%">Method</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr style="cursor: pointer"   :key="indextr3" v-for="(tr, indextr3) in data">

              <vs-td :data="data[indextr3].name">
                {{miscellaneous_display_names[indextr3]}}
              </vs-td>
              <vs-td :data="data[indextr3].max">
                <ValidationProvider :vid="indextr3+'miscellaneous_max'" :name="indextr3+'miscellaneous_max'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr3].max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr3].frequency">
                <ValidationProvider :vid="indextr3+'miscellaneous_frequency'" :name="indextr3+'miscellaneous_frequency'" rules="" v-slot="{ errors }">
                  <v-select :append-to-body="true" :closeOnSelect="true" v-model="data[indextr3].frequency"
                            :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly', 'each batch']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                  <span class="text-danger text-sm">{{ errors[0] }}</span>
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr3].accreditation">
                <ValidationProvider :vid="indextr3+'miscellaneous_accreditation'" :name="indextr3+'miscellaneous_accreditation'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr3].accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

              <vs-td :data="data[indextr3].method">
                <ValidationProvider :vid="indextr3+'miscellaneous_method'" :name="indextr3+'miscellaneous_method'" rules="" v-slot="{ errors }">
                  <vs-input type="text" v-model="data[indextr3].method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                </ValidationProvider>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>


        <!--        <div v-for="(miscellaneous, index5) in form.miscellaneous" :key="index5">-->
        <!--          <div class="vx-row mb-3">-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index5+'miscellaneous_name'" :name="index5+'miscellaneous_name'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Name</small> <br>-->
        <!--                <span class="text-bold" style="font-weight: normal">{{ miscellaneous.name}}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index5+'miscellaneous_max'" :name="index5+'miscellaneous_max'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Maximum levels</small>-->
        <!--                <vs-input type="text" v-model="miscellaneous.max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index5+'miscellaneous_frequency'" :name="index5+'miscellaneous_frequency'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Frequency of testing</small>-->
        <!--&lt;!&ndash;                <vs-input type="text" v-model="miscellaneous.frequency" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />&ndash;&gt;-->
        <!--                <v-select :closeOnSelect="true" v-model="miscellaneous.frequency" :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />-->
        <!--                <span class="text-danger text-sm">{{ errors[0] }}</span>-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index5+'miscellaneous_accreditation'" :name="index5+'miscellaneous_accreditation'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Laboratory Accreditation</small>-->
        <!--                <vs-input type="text" v-model="miscellaneous.accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--            <div class="vx-col md:w-1/5 w-full md:mb-0">-->
        <!--              <ValidationProvider :vid="index5+'miscellaneous_method'" :name="index5+'miscellaneous_method'" rules="" v-slot="{ errors }">-->
        <!--                <small class="label">Method</small>-->
        <!--                <vs-input type="text" v-model="miscellaneous.method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
        <!--              </ValidationProvider>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <vs-divider class="my-4" style="opacity: 0.2" color="" position="center"/>-->
        <!--        </div>-->

        <!--is_illegal_dyes start-->
        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-1/3 md:mb-0">
            <ValidationProvider vid="is_illegal_dyes" name="is_illegal_dyes" rules="" v-slot="{ errors }">
              <small class="label">Does this contain illegal dyes?</small>
              <vs-switch v-model="form.is_illegal_dyes" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="form.is_illegal_dyes" v-for="(illegal_dye, index3) in form.illegal_dye" :key="index3">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index3+'illegal_dye_other_name'" :name="index3+'illegal_dye_other_name'" rules="" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input type="text" v-model="illegal_dye.name" name="name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index3+'illegal_dye_other_max'" :name="index3+'illegal_dye_other_max'" rules="" v-slot="{ errors }">
                <small class="label">Maximum levels</small>
                <vs-input type="text" v-model="illegal_dye.max" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index3+'illegal_dye_other_frequency'" :name="index3+'illegal_dye_other_frequency'" rules="required" v-slot="{ errors }">
                <small class="label">Frequency of testing</small>
                <!--                <vs-input type="text" v-model="illegal_dye.frequency" name="max" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />-->
                <v-select :append-to-body="true" :closeOnSelect="true" v-model="illegal_dye.frequency" :options="['daily', 'weekly', 'monthly','quarterly', 'half-yearly', 'yearly']" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index3+'illegal_dye_other_accreditation'" :name="index3+'illegal_dye_other_accreditation'" rules="" v-slot="{ errors }">
                <small class="label">Laboratory Accreditation</small>
                <vs-input type="text" v-model="illegal_dye.accreditation" name="accreditation" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index3+'illegal_dye_other_method'" :name="index3+'illegal_dye_other_method'" rules="" v-slot="{ errors }">
                <small class="label">Method</small>
                <vs-input type="text" v-model="illegal_dye.method" name="method" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-full w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.illegal_dye.length === 1"  class="" @click="deleteIllegalDye(index3)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_illegal_dyes"  @click="addIllegalDye" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add another record</vs-button>
        <!--is_illegal_dyes end-->


        <!--product_tested start-->
        <div class="vx-row mb-3 mt-8">
          <div class="vx-col md:w-full md:mb-0">
            <ValidationProvider vid="is_illegal_dyes" name="is_illegal_dyes" rules="" v-slot="{ errors }">
              <small class="label">If product is tested, please provide copies of recent test results (for batches supplied to ITS where possible) and copies of any laboratory accreditation?</small>
              <vs-switch v-model="form.is_product_tested" icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" class="mt-2 w-16">
                <span slot="on">Yes</span>
                <span slot="off">No</span>
              </vs-switch>
            </ValidationProvider>
          </div>
        </div>

        <div v-if="form.is_product_tested" v-for="(product_tested, index7) in form.product_tested" :key="index7">
          <div class="vx-row mb-3" >
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <ValidationProvider :vid="index7+'tested_name'" :name="index7+'tested_name'" rules="required" v-slot="{ errors }">
                <small class="label">Name</small>
                <vs-input type="text" v-model="product_tested.name" name="name" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
<!--              <ValidationProvider :vid="index7+'tested_file'" :name="index7+'tested_file'" :rules="product_tested.file ? '' : 'file_required'" v-slot="{ errors }">-->
<!--                <small class="label">File</small>-->
<!--                <a target="_blank" v-if="product_tested.file" class="float-right" :href="product_tested.file">view file</a>-->
<!--                <vs-input type="file" style="color:transparent; width:70px;" @change="onUploadProductTestedFile($event, index7)"  name="file" class="w-full"  :danger="!!errors[0]" :danger-text="errors[0]"  />-->
<!--              </ValidationProvider>-->
              <!--              product_tested.file-->
              <small class="label">File</small>
              <file-uploader-not-required v-on:onSetFileName="value => product_tested.file = value" v-on:onClickFileRemove="product_tested.file = null" :file="product_tested.file" :condition="true"/>

            </div>
            <div class="vx-col md:w-1/5 w-full md:mb-0">
              <small class="label">&nbsp;</small>
              <vs-button :disabled="form.product_tested.length === 1" class="" @click="deleteProductTested(index7)" size="small" color="danger" type="filled" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </div>
        </div>
        <vs-button v-if="form.is_product_tested"  @click="addProductTested" size="small" color="success" type="filled" icon-pack="feather" icon="icon-plus">Add another record</vs-button>
        <!--product_tested end-->

        <div class="vx-row mb-3">
          <div class="vx-col w-full">
            <small class="label">Notes</small>
            <vs-textarea v-model="form.notes"/>
          </div>
        </div>


        <div class="flex flex-wrap items-center justify-end">
          <vs-button button="submit" class="ml-auto mt-2">Save and Change</vs-button>
          <vs-button v-if="!isCompleted" @click.stop="onClickMarkAsComplete" class="ml-4 mt-2" type="border" color="warning">Mark As Complete</vs-button>
        </div>
      </form>
    </ValidationObserver>
  </vx-card>

</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory'
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import vSelect from "vue-select";

  const SupplierManufactureRepository = RepositoryFactory.get('supplierManufacture')
  const SupplierRawMaterialRepository = RepositoryFactory.get('supplierRawMaterial')
  const SupplierRepository = RepositoryFactory.get('supplier');
  import FileUploader from '@/components/shared/FileUploader'
  import FileUploaderNotRequired from '@/components/shared/FileUploaderNotRequired'
  import RawMaterialForm from "@/mixins/RawMaterialForm";


  export default {
    name: "SupplierManufacturingHome",
    components: {
      'v-select': vSelect,
      FileUploader,
      FileUploaderNotRequired
    },
    data() {
      return {
        form: {
          heavy_metal: [
            {
              "type": "heavy_metal",
              "name": "arsenic",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "heavy_metal",
              "name": "cadmium",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "heavy_metal",
              "name": "mercury",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "heavy_metal",
              "name": "lead",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            }
          ],
          is_other_heavy_metals: false,
          other_heavy_metal: [
            {
              "type": "other_heavy_metal",
              "name": "",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            }
          ],
          residue: [
            {
              "type": "residue",
              "name": "mycotoxins",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "residue",
              "name": "aflatoxin_B1",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "residue",
              "name": "aflatoxin_B2",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "residue",
              "name": "aflatoxin_G1",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "residue",
              "name": "aflatoxin_G2",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "residue",
              "name": "ochratoxin_A",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            }
          ],
          miscellaneous: [
            {
              "type": "miscellaneous",
              "name": "PAH",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "miscellaneous",
              "name": "PCB",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            },
            {
              "type": "miscellaneous",
              "name": "dioxins",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            }
          ],
          is_illegal_dyes: false,
          illegal_dye: [
            {
              "type": "illegal_dye",
              "name": "",
              "max": "",
              "frequency": "",
              "accreditation": "",
              "method": ""
            }
          ],
          is_product_tested: false,
          product_tested: [
            {
              "name": "",
              "file": ""
            }
          ]
        },
        heavy_metal_display_names: ['Arsenic (As)', 'Cadmium (Cd)', 'Mercury (Hg)', 'Lead (Pb)'],
        residue_display_names: ['Mycotoxins', 'Aflatoxin B1', 'Aflatoxin B2', 'Aflatoxin G1', 'Aflatoxin G2', 'Ochratoxin A'],
        miscellaneous_display_names: ['PAHs (3,4-Benzopyrene) (polyaromatic hydrocarbons)', 'PCBs (polychlorinated biphenyls)', 'Dioxins'],
        id: null,
        status: {},
      }
    },
    props : {
      isCompleted: { default: false },
    },
    mixins: [SuccessMessage, ErrorMessages, RawMaterialForm],
    methods: {
      remove (item) {
        this.chips.splice(this.chips.indexOf(item), 1)
      },
      onClickNext() {
        this.$emit('notify', 1)
      },
      async onClickMarkAsComplete() {
        this.$emit('mark-as-complete', 'is_raw_material_contaminant_pesticide_marked_completed')
      },
      onClickSubmit() {
        this.status.is_raw_material_contaminant_pesticide_complete ? this.$mixinsOpenUpdateConfirm() : this.onClickCreate()
      },

      async onClickUpdate() {
        this.$vs.loading()
        try {
          if (!this.form.is_other_heavy_metals) {
            this.form.other_heavy_metal = []
          }
          if (!this.form.is_illegal_dyes) {
            this.form.illegal_dye = []
          }
          if (!this.form.is_product_tested) {
            this.form.product_tested = []
          }
          const data= (await SupplierRawMaterialRepository.UpdateRawMaterialContaminantsPesticides(this.id, this.form))
          this.showSuccessMessage('Raw Material Contaminants and Pesticides Details Updated!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async onClickCreate() {
        this.$vs.loading()
        try {
          if (!this.form.is_other_heavy_metals) {
            this.form.other_heavy_metal = []
          }
          if (!this.form.is_illegal_dyes) {
            this.form.illegal_dye = []
          }
          if (!this.form.is_product_tested) {
            this.form.product_tested = []
          }
          const data= (await SupplierRawMaterialRepository.CreateRawMaterialContaminantsPesticides(this.form))
          this.showSuccessMessage('Raw Material Contaminants and Pesticides Details Created!')
          this.onClickNext()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },
      async loadData() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialContaminantsPesticides(this.id)).data
        this.form = data
        if (!this.form.is_other_heavy_metals) {
          this.addOtherName()
        }
        if (!this.form.is_illegal_dyes) {
          this.addIllegalDye()
        }
        if (!this.form.is_product_tested) {
          this.addProductTested()
        }
        this.$vs.loading.close()
      },
      async loadStatus() {
        this.$vs.loading()
        const {data} = (await SupplierRawMaterialRepository.getRawMaterialStatus(this.id)).data
        this.status =data
        this.$vs.loading.close()
      },
      addOtherName() {
        this.form.other_heavy_metal.push(
          {
            "type": "other_heavy_metal",
            "name": "",
            "max": "",
            "frequency": "",
            "accreditation": "",
            "method": ""
          }
        )
      },
      addIllegalDye() {
        this.form.illegal_dye.push(
          {
            "type": "illegal_dye",
            "name": "",
            "max": "",
            "frequency": "",
            "accreditation": "",
            "method": ""
          }
        )
      },
      addProductTested() {
        this.form.product_tested.push(
          {
            name: '',
            file: ''
          }
        )
      },
      deleteOtherName(index) {
        this.form.other_heavy_metal.splice(index, 1)
      },
      deleteIllegalDye(index) {
        this.form.illegal_dye.splice(index, 1)
      },
      deleteProductTested(index) {
        this.form.product_tested.splice(index, 1)
      },
      async onUploadProductTestedFile(event, index){
        this.$vs.loading();
        try {
          const file = await event.target.files[0]
          let formData = new FormData();
          formData.append('file', file);
          this.form.product_tested[index].file = (await SupplierRepository.uploadFile(formData)).data.data.file
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close()
      },

    },
    async mounted() {
      this.id = this.$route.params.id
      this.form.supplier_raw_material_id =  this.id
      await this.loadStatus()
      if (this.status.is_raw_material_contaminant_pesticide_complete) {
        await this.loadData()
      }
    }
  }
</script>

<style scoped>

</style>
